<script>
import { mapActions, mapGetters } from 'vuex'
import LABELS from '@/constants/labels'
import { optionsFont, colorList } from '@/constants/data'
import { uniqueId } from '@/helpers/site'

export default {
  name: 'addText',
  data() {
    return {
      colorList,
      visible: false,
      idColorBg: '',
      arrNewText: [],
      optionsFont,
      color: '',
      editingIndex: '',
      maxAddText: 5,
      selectedShapeName: '',
      indexText: null,
      currentItemEditing: '',
      defaultRotate: 0,
      defaultScale: 1,
    }
  },
  created() {
    this.arrNewText = this.getTexts
  },

  computed: {
    ...mapGetters('settings', [
      'getTexts',
      'getModules',
      'getStamps',
      'getBackground',
      'getAvatars',
    ]),
    mappingLabels() {
      return LABELS
    },

    checkSpecialFont() {
      return (
        this.arrNewText.find(item => item.fontFamily === 'Cabin Condensed') !==
        undefined
      )
    },

    filteredOptionsFont() {
      return this.optionsFont.filter(x => {
        if (x.value === 'Cabin Condensed') {
          return !this.arrNewText.map(item => item.fontFamily).includes(x.value)
        }
        return true
      })
    },

    options() {
      if (this.getBackground.logo) {
        return this.optionsFont.filter(item => item.value !== 'Cabin Condensed')
      } else {
        if (typeof this.indexText === 'number') {
          if (this.currentItemEditing === 'Cabin Condensed') {
            return this.optionsFont
          } else {
            return this.filteredOptionsFont
          }
        } else {
          return this.filteredOptionsFont
        }
      }
    },
  },

  methods: {
    ...mapActions('settings', ['setTexts', 'saveToStorage']),
    handleSelectBgColor(id) {
      this.idColorBg = id
    },

    onClickEditText(index) {
      if (this.editingIndex === index) {
        this.editingIndex = ''
      } else {
        this.editingIndex = index
      }
    },
    handleShowOption(index) {
      return this.editingIndex === index
    },

    showModalAddText() {
      this.indexText = null
      this.$nextTick(() => {
        this.$refs.addTextModal && this.$refs.addTextModal.show()
      })
    },

    showModalEditText(item, index) {
      this.indexText = index
      this.currentItemEditing = item.fontFamily
      this.$nextTick(() => {
        this.$refs.addTextModal && this.$refs.addTextModal.show(item, index)
      })
    },

    handleDeleteText(index) {
      this.editingIndex = ''
      this.arrNewText.splice(index, 1)
    },

    handleAddNewText(data, index) {
      if (typeof index === 'number') {
        this.$set(this.arrNewText, index, {
          ...this.arrNewText[index],
          text: data.text,
          fontFamily: data.fontFamily,
        })
      } else {
        this.arrNewText.push({
          ...data,
          x: 0,
          y: 0,
          text: data.text,
          id: uniqueId('text'),
          fontFamily: data.fontFamily,
          rotation: 0,
          scaleX: 1,
          scaleY: 1,
          color: '#000000',
        })
      }
    },

    displayAddText() {
      return this.arrNewText.length < this.maxAddText ? true : false
    },

    handldSubmitAddText() {
      this.setTexts(this.arrNewText)
      this.saveToStorage()

      this.$router.push({
        name: 'preview',
      })
    },

    handleRotate(value) {
      if (this.editingIndex) {
        this.arrNewText.find(
          item => item.id === this.editingIndex
        ).rotation = +value
        this.defaultRotate = +value
      }
    },

    handleZoom(value) {
      if (this.editingIndex) {
        const currentObject = this.arrNewText.find(
          item => item.id === this.editingIndex
        )
        currentObject.scaleX = +value
        currentObject.scaleY = +value

        this.defaultScale = +value
      }
    },

    selectChange(value) {
      if (value) {
        const currentObject = this.arrNewText.find(item => item.id === value)
        this.editingIndex = value

        this.defaultRotate = +currentObject.rotation
        this.defaultScale = +currentObject.scaleX
      } else {
        this.editingIndex = ''
      }
    },

    onChangeColor(color, index) {
      this.$set(this.arrNewText, index, {
        ...this.arrNewText[index],
        color: color,
      })
    },
    handleOpenColorPicker(idx, defaultColor) {
      this.$nextTick(() => {
        this.$refs.verte && this.$refs.verte.show(defaultColor, idx)
      })
    },
  },
}
</script>

<template>
  <div>
    <s-header :hasPreview="true">{{ mappingLabels.textTitle }}</s-header>
    <div class="text-page">
      <div class="text-page_container">
        <div class="wrap-content" :class="{ 'overlay-bg': visible }">
          <div class="text-page_image">
            <s-preview
              :textDraw="arrNewText"
              :backgroundDraw="getModules.background"
              :avatarDraw="getModules.avatars"
              :stampDraw="getModules.stamps"
              :selectedName="editingIndex"
              currentMove="text"
              @onchangeSelect="selectChange"
            />
          </div>
          <div class="text_layout">
            <div class="text_layout_wrapper">
              <div class="input-range">
                <s-range-input
                  :label="'角度'"
                  :min="-180"
                  :max="180"
                  :value="defaultRotate"
                  :step="15"
                  :disabled="!editingIndex"
                  @on-input="handleRotate"
                />
                <s-range-input
                  :label="'大きさ'"
                  :min="0.27"
                  :max="6"
                  :value="defaultScale"
                  :step="0.05"
                  :disabled="!editingIndex"
                  @on-input="handleZoom"
                />
              </div>
              <div class="text-page_content">
                <div class="group-new-text">
                  <div
                    class="group-new-text_wrap"
                    v-for="(item, index) in arrNewText"
                    :key="index"
                  >
                    <div
                      class="group-new-text_text"
                      :class="{ 'show-option': handleShowOption(item.id) }"
                    >
                      <p class="text" @click="onClickEditText(item.id)">
                        {{ item.text }}
                      </p>
                      <div class="icon-group">
                        <span
                          class="icon-delete"
                          @click="handleDeleteText(index)"
                          ><x-icon-text-delete :reverse="true" />
                        </span>
                        <span
                          class="icon-edit"
                          @click="showModalEditText(item, index)"
                        >
                          <x-icon-text-edit :reverse="true" />
                        </span>
                        <span
                          class="square-color"
                          :style="`background-color: ${item.color}`"
                          @click="handleOpenColorPicker(index, item.color)"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <p
                    class="btn-add-text"
                    :class="{ 'display-add-text': !displayAddText() }"
                    @click="showModalAddText()"
                  >
                    <span class="icon">+</span>
                    <label>{{ mappingLabels.addText }}</label>
                  </p>
                </div>
                <p class="note" v-html="mappingLabels.noteAddText"></p>
              </div>
            </div>
          </div>
        </div>
        <s-navigate-bar
          class="navigate-bar-fixed"
          @leftClick="$router.push({ name: 'preview' })"
          @rightClick="handldSubmitAddText"
          >{{ mappingLabels.decideAndBackToPreviewText }}</s-navigate-bar
        >
        <s-modal-add-text
          ref="addTextModal"
          :optionsFont="options"
          @submit="handleAddNewText"
        ></s-modal-add-text>
        <s-modal-avatar-color
          ref="verte"
          :palette="colorList"
          @on-change="onChangeColor"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'addText.scss';
</style>
